export enum PermissionOperation {
    read = 'read',
    write = 'write',
    write_fraud_risk_invoice = 'write_fraud_risk_invoice',
    write_service_invoice = 'write_service_invoice',
    write_advance_invoice = 'write_advance_invoice',
}
